import React, { useContext, useState } from 'react'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext';
import { Grid, Switch, useMediaQuery } from '@mui/material';
import { emptyChatbotExceptionObject, emptyStepExceptionObject, isCurrentViewVersionPublished } from '../../utilityFunctions';
import globalStyles from '../../../../../assets/styles/global.module.scss';
import fieldStyles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'; 
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { staticWorkflowChatbotDetails } from '../../../../../models/axiosModel';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import ExceptionPopup from './exceptionPopup';
import { generateUUID } from '../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import { useSearchParams } from 'react-router-dom';

interface ChatbotExceptionNewProps {
    flagStepLevel?: boolean, 
    stepId?: string,
}

const ChatbotExceptionNew: React.FC<ChatbotExceptionNewProps> = (props) => { 

    const { flagStepLevel, stepId } = props;
    const { currentActiveStaticWorkflow, setCurrentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload; 
    const { nodes, setNodes, updateException, getChatbotPostDeploymentTriggerTypeApi, chatbotPostDeploymentTriggerType } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { handleError, setFlagLoading } = useContext(UserContext) as UserContextPayload

    const [flagExceptionPopup, setFlagExceptionPopup] = useState<boolean>(false);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }
    const [searchParams] = useSearchParams();
    const chatbotId = searchParams.get('workflow_id');

    const getHandleErrorSwitchValue = () => {
        if(flagStepLevel){
            if(nodes?.find((node: any) => node?.id == stepId)?.chatbot_step_exception){
                return true;
            } else return false;
        } 
        else {
            if(currentActiveStaticWorkflow?.chatbot_exception) return true;
            else return false;
        }
    } 

    const isExceptionSavedInBE = () => {
        if(!currentActiveStaticWorkflow) return false;
        if(flagStepLevel){
            const stepException = nodes?.find((node: any) => node?.id == stepId)?.chatbot_step_exception; 
            if(stepException){
                return stepException?.flag_saved_in_BE;
            } 
            return false;
        } else {
            const chatbotException = currentActiveStaticWorkflow?.chatbot_exception; 
            if(chatbotException){
                return chatbotException?.flag_saved_in_BE;
            }
            return false;
        }
    }

    const onChangeOfHandleErrorSwitch = (value: boolean) => {
        if(flagStepLevel){
            setNodes((prev: any) => {
                return prev?.map((node: any) => {
                    if(node?.id == stepId){
                        return {
                            ...node, 
                            chatbot_step_exception: value ? emptyStepExceptionObject(generateUUID()) : null,
                        }
                    }
                    return node;
                })
            })

            if(isExceptionSavedInBE() && !value){
                const step_type_id = nodes?.find((node: any) => node?.id == stepId)?.chatbot_step_type_id;
                updateException(nodes, stepId, step_type_id, true);
            }

        } else {
            setCurrentActiveStaticWorkflow((prev: staticWorkflowChatbotDetails | null) => {
                if(!prev) return null;
                return {
                    ...prev, 
                    chatbot_exception: value ? emptyChatbotExceptionObject(generateUUID()) : null,
                }
            }) 
            if(isExceptionSavedInBE() && !value){
                handlePostDeploymentTrigger(true);
            }
        }
    }

    const handleExceptionEditClick = () => {
        setFlagExceptionPopup(true); 
        if(flagStepLevel){
            setNodes((prev: any) => {
                return prev?.map((node: any) => {
                    if(node?.id == stepId){
                        return {
                            ...node, 
                            chatbot_step_exception: node?.chatbot_step_exception ? {
                                ...node.chatbot_step_exception, 
                                temp_step_exception: node.chatbot_step_exception,
                            } : null,
                        }
                    }
                    return node;
                })
            })

        } else {
            setCurrentActiveStaticWorkflow((prev: staticWorkflowChatbotDetails | null) => {
                if(!prev) return null;
                return {
                    ...prev, 
                    chatbot_exception: prev?.chatbot_exception ? {
                        ...prev?.chatbot_exception, 
                        temp_chatbot_exception: prev?.chatbot_exception,
                    } : null,
                }
            })
        }   
    } 

    const showErrorConfigurationMessage = () => { 
        if(!currentActiveStaticWorkflow) return "";  
        const stepException = nodes?.find((node: any) => node?.id == stepId)?.chatbot_step_exception;
        const chatbotException = currentActiveStaticWorkflow?.chatbot_exception;
        let exception;
        if(flagStepLevel){ 
            exception = stepException;
        } else { 
            exception = chatbotException;
        } 
        if(exception){
            if(exception?.flag_saved_in_BE){
                switch(exception?.action_type){
                    case "ReDeploy": 
                        return "Restart chatbot from the beginning";
                    case "ReDirect": 
                        return "Re-Direct user to another step";
                    case "Do Nothing": 
                        return "Ignore error";
                    default: 
                        return "Please handle error";
                }
            }
            return "Please handle error";
            }
            return "";
    } 

    const getChatbotPostDeploymentTriggerTypeApiCall = async () => {
        const res = await getChatbotPostDeploymentTriggerTypeApi(); 
        if(!(res.status)){
            handleError(res);
        } 
        return res?.data || null;
    }

    const handlePostDeploymentTrigger = async (flag_delete: boolean) => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        let triggerType = chatbotPostDeploymentTriggerType;
        if(!chatbotPostDeploymentTriggerType){
            triggerType = await getChatbotPostDeploymentTriggerTypeApiCall();
        } 

        const chatbotException = currentActiveStaticWorkflow?.chatbot_exception;
        const payload = {
            chatbot_post_deployment_trigger_id: chatbotException?.chatbot_post_deployment_trigger_id || "", 
            chatbot_post_deployment_trigger_type: {
                chatbot_post_deployment_trigger_type_id: triggerType?.find((trigger) => trigger?.chatbot_post_deployment_trigger_type_name?.toLowerCase() == "exception")?.chatbot_post_deployment_trigger_type_id || "", 
            }, 
            chatbot_step: {
                chatbot_step_id: chatbotException?.chatbot_step?.chatbot_step_id || "",
            }, 
            pre_transition_text_message: chatbotException?.pre_transition_text_message || "", 
            flag_deleted: flag_delete,
        }

        const res = await agent.handleChatbotPostDeploymentTrigger.post(payload, chatbotId || "");
        if(!res.status){
            handleError(res);
        }

        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    } 

    const onClickOfCancel = () => {
        if(flagStepLevel){
            setNodes((prev: any) => {
                return prev?.map((node: any) => {
                    if(node?.id == stepId){
                        return {
                            ...node, 
                            chatbot_step_exception: node?.chatbot_step_exception?.temp_step_exception ?? null,
                        }
                    }
                    return node;
                })
            })
        } else {
            setCurrentActiveStaticWorkflow((prev: staticWorkflowChatbotDetails | null) => {
                if(!prev) return null;
                return {
                    ...prev, 
                    chatbot_exception: prev?.chatbot_exception?.temp_chatbot_exception ?? null,
                }
            })
        } 
        setFlagExceptionPopup(false);
    } 

    return (
        <>
            <Grid item sx={{ width: "100%" }}>
                <Grid container direction={"column"} gap={"10px"}>
                    <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                        <Grid container justifyContent={"space-between"} alignContent={"center"}>
                            <Grid item className={`${globalStyles.displayFlex} ${styles.handleErrorTitle}`}>Handle Error</Grid>
                            <Grid item>
                                <Switch
                                    disabled={flagStepLevel ? isCurrentViewVersionPublished(currentActiveStaticWorkflow) : false}
                                    checked={getHandleErrorSwitchValue()}
                                    onChange={(e) => onChangeOfHandleErrorSwitch(e.target.checked)}
                                />
                            </Grid>
                        </Grid>
                    </Grid> 

                    {getHandleErrorSwitchValue() && 
                        <>
                            <Grid item xs={12} className={`${textStyles.templatesContainer}`}>
                                <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                                    <Grid item className={styles.exceptionTitle}>
                                        {flagStepLevel ? "When an error occurs in this step:" : "When an error occurs in this chatbot:"}
                                    </Grid>
                                    <Grid item className={styles.contentBlockSubHeadingStyle} sx={{ '&:hover': { backgroundColor: "rgba(0,0,0,0.02)" }, padding: "2px 4px" }}>
                                        <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                            <Grid item sx={{ wordBreak: "break-word" }}>
                                                {showErrorConfigurationMessage()}
                                            </Grid>
                                            <Grid item>
                                                <ModeEditIcon
                                                    className={styles.editIcon}
                                                    onClick={() => handleExceptionEditClick()}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    }
                </Grid>
            </Grid> 

            {flagExceptionPopup && 
                <GlobalPopUp
                    open={flagExceptionPopup}
                    onClose={() => { setFlagExceptionPopup(false); onClickOfCancel();}}
                    handleClose={() => { setFlagExceptionPopup(false); onClickOfCancel();}}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "700px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "800px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <ExceptionPopup
                        setFlagExceptionPopup={setFlagExceptionPopup}
                        handlePostDeploymentTrigger={handlePostDeploymentTrigger}
                        onClickOfCancel={onClickOfCancel}
                        flagStepLevel={flagStepLevel} 
                        stepId={stepId} 
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default ChatbotExceptionNew
